<template>
  <div class="bespread-wrap module-layer1">
    <div class="screen-container">
      <div class="kv-content">
        <div class="b-position">
          <div class="page-channel-list">
            <div class="page-channel-item ios-icon">
              <img
                :src="require('../../assets/img/layer1/' + lang + '/ios.png')"
                alt=""
                srcset=""
                @click="AS_reg('ios')"
              />
            </div>
            <div class="page-channel-item gp-icon">
              <img
                :src="require('../../assets/img/layer1/' + lang + '/gp.png')"
                alt=""
                srcset=""
                @click="GP_reg('gp')"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 首页视频 -->
      <video
        loop
        muted
        autoplay
        class="video-bg2 video-size"
        id="bgVideo"
        ref="bgVideo"
      >
        <source
          src="https://resource-mp4.ujoygames.com/sofm/bg.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  props: ["language"],

  data() {
    return {
      lang: localStorage.getItem("sof_locale") || "en"
    };
  },
  watch: {
    // 监听到父组件传递过来的数据后，加工一下，
    // 存到data中去，然后在页面上使用
    language(newVal, oldVal) {
      this.lang = newVal;
    }
  },
  created() {},
  methods: {
    AS_reg(val) {
      this.common.goShare(val);
    },
    GP_reg(val) {
      this.common.goShare(val);
    },
    pay_reg(val) {
      this.common.goShare(val);
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer1 {
  .screen-container {
    background-image: url("../../assets/img/layer1/bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .kv-play-btn {
      width: 128px;
      height: auto;
       position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
    .kv-content {
      position: absolute;
      bottom: 3.2vw;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      z-index: 1;

      .kv-slogan {
        // width: 733px;
        // height: 271px;
        width: 945px;
        height: auto;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .b-position {
        .page-channel-list {
          display: flex;
          align-items: end;
          justify-content: end;
          gap:3vw;

          .page-channel-item {
            cursor: pointer;
            width: auto;
            height: 80px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .module-layer1 {
    .kv-content {
      bottom: 8vw !important;
    }
  }
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer1 {
    .kv-content {
      bottom: 6vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer1.vue